import { useMe, useMarkHintSeen } from "@/api/hooks";
import { InstructionFlow } from "@/components/instruction/InstructionKit";
import { SECTION_STEPS } from "@/components/instruction/content";

/**
 * SectionHint — контекстна підказка розділу (1-3 кроки), показується 1 раз
 * при першому вході. Монтується на сторінці розділу: <SectionHint hint="feed"/>.
 *
 * Гейт: підписник (або адмін для тесту), що пройшов базову інструкцію ('basic')
 * і ще не бачив цю підказку. Після проходження — POST /instruction/seen.
 */
export function SectionHint({ hint }: { hint: string }) {
  const me = useMe();
  const mark = useMarkHintSeen();
  const d = me.data;
  const steps = SECTION_STEPS[hint];

  const eligible =
    !!d &&
    !!steps &&
    d.onboarding_completed &&
    (d.has_active_subscription || d.is_admin) &&
    d.seen_hints.includes("basic") &&
    !d.seen_hints.includes(hint);

  if (!eligible) return null;

  return (
    <InstructionFlow
      steps={steps}
      eyebrow="Інструкція · обовʼязково"
      finishLabel="Зрозуміло"
      onDone={() => mark.mutate(hint)}
    />
  );
}
